import { TASK_MAIL_STATUS } from '../../constant';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
const isFn = (params) => {
    return typeof params === 'function';
};
const mergeCallback = (userConfig, defaultConfig) => {
    if (userConfig != null) {
        if (isFn(userConfig)) {
            if (isFn(defaultConfig)) {
                return (mail) => {
                    const _userConfig = userConfig;
                    return _userConfig(mail, defaultConfig);
                };
            }
            else {
                return (mail) => {
                    const _userConfig = userConfig;
                    return _userConfig(mail, () => defaultConfig);
                };
            }
        }
        else {
            return userConfig;
        }
    }
    return defaultConfig;
};
export const findAndMergeDefaultMenuConfig = (cutConfig, defaultConfig) => {
    let configList = [];
    cutConfig.forEach(item => {
        if (item) {
            const { key } = item;
            const config = defaultConfig[key];
            configList.push(mergeMenuItemConfig(item, config));
        }
    });
    return configList;
};
export const mergeMenuItemConfig = (userCofig, baseConfig) => {
    if (!userCofig && baseConfig) {
        return baseConfig;
    }
    if (!baseConfig && userCofig) {
        return userCofig;
    }
    let res = Object.assign(Object.assign({}, baseConfig), userCofig);
    res['show'] = mergeCallback(userCofig.show, baseConfig.show);
    res['onClick'] = mergeCallback(userCofig.onClick, baseConfig.onClick);
    return res;
};
const Max = 1000;
const scanConfig = (config, callBack, getEnd = () => true) => {
    if (config && (config === null || config === void 0 ? void 0 : config.length)) {
        return config.map(item => {
            if (item) {
                if ((item === null || item === void 0 ? void 0 : item.subMenus) && Array.isArray(item === null || item === void 0 ? void 0 : item.subMenus) && getEnd()) {
                    const res = scanConfig(item === null || item === void 0 ? void 0 : item.subMenus, callBack, getEnd);
                    return callBack(Object.assign(Object.assign({}, item), { subMenus: res }));
                }
                return callBack(item);
            }
            return item;
        });
    }
    return [];
};
export const mergeMenuConfig = (userCofig = [], baseConfig = []) => {
    const userMenuMap = {};
    let res = baseConfig;
    try {
        const userCofigQueue = [...userCofig];
        let count = 0;
        while (userCofigQueue.length) {
            if (count >= Max) {
                console.error('mergeMenuConfig error: userCofig has circular reference', 'Max:', Max);
                break;
            }
            const task = userCofigQueue.shift();
            if (task && task.key != null) {
                userMenuMap[task.key] = task;
                if ((task === null || task === void 0 ? void 0 : task.subMenus) && Array.isArray(task === null || task === void 0 ? void 0 : task.subMenus)) {
                    task === null || task === void 0 ? void 0 : task.subMenus.forEach(item => {
                        if (item.key != null && !userMenuMap[task.key]) {
                            userCofigQueue.push(item);
                        }
                    });
                }
            }
            count++;
        }
        count = 0;
        res = scanConfig(baseConfig, (item) => {
            if (item.key != null) {
                if (userMenuMap[item.key]) {
                    const userMenuItem = userMenuMap[item.key];
                    return mergeMenuItemConfig(userMenuItem, item);
                }
            }
            count++;
            return item;
        }, () => {
            if (count >= Max) {
                console.error('mergeMenuConfig error: userCofig has circular reference', 'Max:', Max);
                return false;
            }
            return true;
        });
    }
    catch (e) {
        console.error('mergeMenuConfig error:', e);
        return baseConfig;
    }
    return res;
};
export const mergeMenuConfigSimple = (userCofig, baseConfig) => {
    const userMenuMap = {};
    userCofig.forEach(item => {
        if (item.key != null) {
            userMenuMap[item.key] = item;
        }
    });
    const localData = baseConfig.map(item => {
        if (item.key != null) {
            if (userMenuMap[item.key]) {
                const userMenuItem = userMenuMap[item.key];
                return mergeMenuItemConfig(userMenuItem, item);
            }
        }
        return Object.assign({}, item);
    });
    return localData;
};
export const getShowByFolder = (mail, list) => {
    const { folder } = (mail === null || mail === void 0 ? void 0 : mail.entry) || {};
    if (folder && list && list.length) {
        return list.some(item => item === folder);
    }
    return false;
};
export const taskMailMenuShow = (mails, defaultShow) => {
    const mail = getMailFromMails(mails);
    const { taskInfo } = mail;
    if ((taskInfo === null || taskInfo === void 0 ? void 0 : taskInfo.status) === TASK_MAIL_STATUS.PROCESSING) {
        return false;
    }
    return !!defaultShow ? defaultShow(mail) : true;
};
export const proxyTaskMailClick = (mails, defaultClick) => {
    const mail = getMailFromMails(mails);
    const { taskId, taskInfo } = mail;
    if (taskId && taskInfo && (taskInfo === null || taskInfo === void 0 ? void 0 : taskInfo.status) === TASK_MAIL_STATUS.PROCESSING) {
        message.info({ content: getIn18Text('WEIWANCHENGDEREN') });
        return false;
    }
    return defaultClick && defaultClick(mail);
};
export const timeOutRequest = (task, timeout) => {
    const timeoutTask = new Promise((_, j) => {
        setTimeout(() => {
            j();
        }, timeout);
    });
    return Promise.race([task, timeoutTask]);
};
